@if (drawerOpen()) {
  <div class="z-drawer-backdrop" (click)="uiService.closeSidebar()"></div>
}

<aside #panel
       class="side-bar"
       id="panel-lateral"
       tabindex="-1"
       [class.collapsed]="isRail()"
       [class.drawer]="isOverlay()"
       [class.open]="drawerOpen()"
       [attr.inert]="drawerClosed() ? '' : null"
       [attr.role]="isOverlay() ? 'dialog' : null"
       [attr.aria-modal]="isOverlay() ? 'true' : null"
       [attr.aria-label]="isOverlay() ? 'Menú de secciones' : null">

  <div class="logo-box">
    <img src="assets/images/logo-zorro.png" alt="Zorro Abarrotero" />

    @if (isOverlay()) {
      <button class="drawer-close" type="button" (click)="uiService.closeSidebar()"
              aria-label="Cerrar el menú">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    }
  </div>

  <nav class="menu z-rise" aria-label="Secciones del tablero">
    @if (!isRail()) {
      <p class="menu-caption">Secciones</p>
    }

    @for (item of menuData; track item.route) {
      <app-menu-item
        [menuItem]="item"
        [hint]="hints[item.route]"
        [collapsed]="isRail()" />
    }
  </nav>

  @if (!isRail()) {
    <div class="user-box z-rise z-rise-2">
      <span class="avatar"><i class="bi bi-person-fill" aria-hidden="true"></i></span>
      <span class="name">{{ uiService.userName }}</span>
      <button class="power" type="button" (click)="salir()" aria-label="Cerrar sesión">
        <i class="bi bi-power" aria-hidden="true"></i>
      </button>
    </div>
  }

</aside>
